import {
    boolean,
    snakeCase,
    text,
    timestamp,
    varchar,
} from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { userStatusEnum } from './_common.table'
import { clientsTable } from './clients.table'
import { vendorsTable } from './vendors.table'

export const usersTable = snakeCase.table('users', {
    id: id('usr'),
    restauthUserId: varchar({ length: 255 }).notNull().unique(),
    restauthMembershipId: varchar({
        length: 255,
    }).notNull(),
    vendorId: text().references(() => vendorsTable.id, {
        onDelete: 'cascade',
        onUpdate: 'cascade',
    }),
    clientId: text().references(() => clientsTable.id, {
        onDelete: 'cascade',
        onUpdate: 'cascade',
    }),
    firstName: varchar({ length: 100 }).notNull(),
    lastName: varchar({ length: 100 }).notNull(),
    email: varchar({ length: 255 }).notNull().unique(),
    phone: varchar({ length: 30 }),
    isOwner: boolean().default(false),
    status: userStatusEnum().notNull().default('active'),
    lastLogin: timestamp({ withTimezone: true }),
    ...timestamps,
})
